// import { AuthConfig } from 'angular-oauth2-oidc';
// import { Capacitor } from '@capacitor/core';
// import { environment } from './environments/environment';

// const origin = globalThis.location?.origin ?? 'http://localhost:4200';

// const nativeCallbackUri = 'com.badungkab.sikapbadung://auth/callback';
// const webCallbackUri = `${origin}/auth/callback`;

// const webLogoutUri = `${origin}/landing`;
// const nativeLogoutUri = 'com.badungkab.sikapbadung://landing';

// export const authConfig: AuthConfig = {
//   issuer: environment.sso.issuer,
//   redirectUri: Capacitor.isNativePlatform()
//     ? nativeCallbackUri
//     : webCallbackUri,
//   postLogoutRedirectUri: Capacitor.isNativePlatform()
//     ? nativeLogoutUri
//     : webLogoutUri,
//   clientId: environment.sso.clientId,
//   responseType: 'code',
//   scope: 'openid profile email offline_access',
//   requireHttps: false,
//   strictDiscoveryDocumentValidation: false,
//   showDebugInformation: true,
//   useSilentRefresh: false,
// };

import { AuthConfig } from 'angular-oauth2-oidc';
import { Capacitor } from '@capacitor/core';
import { Env } from './app/models/Env';

export function getAuthConfig(activeEnv: Env): AuthConfig {
  const origin = globalThis.location?.origin ?? 'http://localhost:4200';

  const nativeCallbackUri = 'com.badungkab.sikapbadung://auth/callback';
  const webCallbackUri = `${origin}/auth/callback`;

  const webLogoutUri = `${origin}/public-monitor`;
  const nativeLogoutUri = 'com.badungkab.sikapbadung://public-monitor';

  return {
    issuer: activeEnv.sso.issuer,
    clientId: activeEnv.sso.clientId,

    redirectUri: Capacitor.isNativePlatform()
      ? nativeCallbackUri
      : webCallbackUri,
    postLogoutRedirectUri: Capacitor.isNativePlatform()
      ? nativeLogoutUri
      : webLogoutUri,

    responseType: 'code',
    scope: 'openid profile email offline_access',
    requireHttps: false,
    strictDiscoveryDocumentValidation: false,
    showDebugInformation: true,
    useSilentRefresh: false,
  };
}
